import { REACT_APP_API } from '../../config'
import axios from 'axios'

export async function getDashboard(bType, isLeadsDashboard = false) {
    const queryLeads = isLeadsDashboard && '&leads=true'

    const queryParams = [
        `b_type=${bType}`,
    ]

    if (queryLeads) queryParams.push(`&leads=true`)

    const $queryString = queryParams.join("");

    const url = `${REACT_APP_API}/dashboard/config?${$queryString}`
    const response = await axios.get(url)
    return response.data
}
